import * as Type from './actionsTypes';

const createProcedimentosNormas  = (data, callback) => ({ type: Type.PROCEDIMENTOS_NORMAS_CREATE, data, callback });

const procedimentosNormasClearSelected = () => ({ type: Type.PROCEDIMENTOS_NORMAS_CLEAR_SELECTED });

const updateProcedimentosNormas = (id, data, callback) => ({ type: Type.PROCEDIMENTOS_NORMAS_UPDATE, id, data, callback });

const findProcedimentosNormasById = (id, callback) => ({ type: Type.PROCEDIMENTOS_NORMAS_FIND_ONE, id, callback });

const procedimentosNormasCancelStatus = (id, data, callback) => ({ type: Type.PROCEDIMENTOS_NORMAS_CANCEL_STATUS, id, data, callback });

const procedimentosNormasConfirmStatus = (id, callback) => ({ type: Type.PROCEDIMENTOS_NORMAS_CONFIRM_STATUS, id, callback });

const deleteProcedimentoNorma = (id, callback) => ({ type: Type.PROCEDIMENTOS_NORMAS_DELETE, id, callback });

export {
  createProcedimentosNormas,
  procedimentosNormasClearSelected,
  findProcedimentosNormasById,
  updateProcedimentosNormas,
  procedimentosNormasCancelStatus,
  procedimentosNormasConfirmStatus,
  deleteProcedimentoNorma,
}
